import ReactRouterPropTypes from 'react-router-prop-types';

export default {
  history: ReactRouterPropTypes.history,
  location: ReactRouterPropTypes.location,
  match: ReactRouterPropTypes.match,
  route: ReactRouterPropTypes.route,
};



// WEBPACK FOOTER //
// ../utils/proptypes/react-router.js